import { render } from "./nahalMerhavia.vue?vue&type=template&id=56678a37&scoped=true"
import script from "./nahalMerhavia.vue?vue&type=script&lang=js"
export * from "./nahalMerhavia.vue?vue&type=script&lang=js"

import "./nahalMerhavia.vue?vue&type=style&index=0&id=56678a37&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56678a37"]])

export default __exports__